import React, { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  DURATION_BUCKETS,
  buildBucketPerformance,
  getTradeDurationMinutes,
} from '../../lib/trades/dashboardBucketAnalytics';

interface PerformanceByDurationWidgetProps {
  timeRange: 'week' | 'month' | 'year';
  size: WidgetSize;
  trades?: any[];
}

export const PerformanceByDurationWidget: React.FC<PerformanceByDurationWidgetProps> = ({ 
  timeRange, 
  size, 
  trades = [],
}) => {
  const perfData = useMemo(
    () => buildBucketPerformance({ trades, timeRange, buckets: DURATION_BUCKETS, metric: getTradeDurationMinutes }),
    [timeRange, trades]
  );

  return (
    <BucketPerformanceList
      result={perfData}
      size={size}
      emptyTitle="No duration data yet."
      emptyMessage="Import trades with entry and exit times to see this widget."
      unavailableMessage="Import trades with entry and exit times to see this widget."
    />
  );
};
